export const getGlobalRound = state => state.globalRound.data;
export const getPartnerSettings = state => state.partnerSettings.data;
export const getCompetitions = state => state.competitions.data.competitions;

